import { useEffect, useState } from 'react';

const useScreenWidth = (cssQuery:string='(max-width: 768px)') => {
  const [matches, setMatches] = useState(() => {
    if(typeof window !== 'undefined') {
      return window.matchMedia(cssQuery).matches;
    }
    return false;
  });

  useEffect(() => {
    if(typeof window === 'undefined') return;
    const width = window.matchMedia(cssQuery);
    const listener = (event: MediaQueryListEvent) => setMatches(event.matches);

    if(width.addEventListener) {
      width.addEventListener('change', listener);
    } else {
      width.addListener(listener);
    }

    setMatches(width.matches);

    return () => {
      if(width.removeEventListener) {
        width.removeEventListener('change', listener);
      } else {
        width.removeListener(listener);
      }
    }
  }, [cssQuery]);

  return matches;
};

export default useScreenWidth;
